export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

export const SIZE_TIERS = {
  PEA: 1,
  MARBLE: 2,
  GOLF_BALL: 3,
  SOFTBALL: 4,
  BASKETBALL: 5,
  EMERGE: 6,
} as const;

export type SizeTier = (typeof SIZE_TIERS)[keyof typeof SIZE_TIERS];

export const SENTIENCE_THRESHOLDS = {
  SILENT: 0,
  PRIMITIVE_DRIVES: 0.1,
  ICON_SYMBOLS: 0.3,
  ANIMAL_CAP: 0.5,
  AWAKENED: 0.9,
} as const;
